import { schema } from 'normalizr';

const meteringPointReviewSchema = new schema.Entity('meteringPointReview');

export default meteringPointReviewSchema;
